module.exports = __webpack_public_path__ + "media/stylesheets/images/logo-white-3940066efe1f4dfe2bf85dad1f7579d7.png";